import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM3.6 24C3.6 35.2666 12.7334 44.4 24 44.4C35.2666 44.4 44.4 35.2666 44.4 24C44.4 12.7334 35.2666 3.6 24 3.6C12.7334 3.6 3.6 12.7334 3.6 24Z",
      fill: "#F2F2F2",
      id: "progress-circle"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24 0C27.1517 0 30.2726 0.620778 33.1844 1.82689C36.0962 3.033 38.742 4.80083 40.9706 7.02944C43.1992 9.25804 44.967 11.9038 46.1731 14.8156C47.3792 17.7274 48 20.8483 48 24C48 27.1517 47.3792 30.2726 46.1731 33.1844C44.967 36.0962 43.1992 38.742 40.9706 40.9706C38.742 43.1992 36.0962 44.967 33.1844 46.1731C30.2726 47.3792 27.1517 48 24 48L24 44.4C26.679 44.4 29.3317 43.8723 31.8067 42.8471C34.2818 41.8219 36.5307 40.3193 38.425 38.425C40.3193 36.5307 41.8219 34.2818 42.8471 31.8067C43.8723 29.3317 44.4 26.679 44.4 24C44.4 21.321 43.8723 18.6683 42.8471 16.1933C41.8219 13.7182 40.3193 11.4693 38.425 9.57502C36.5307 7.68071 34.2818 6.17805 31.8067 5.15286C29.3317 4.12766 26.679 3.6 24 3.6V0Z",
      fill: "#439f7f"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.6016 29V20.6533H17.5674L14.9902 22.4854V20.9814L17.5879 19.1357H19.0986V29H17.6016ZM22.0518 31.1055H20.7393L24.2393 19.1357H25.5518L22.0518 31.1055ZM26.2354 22.0273C26.2354 20.25 27.6641 18.9512 29.626 18.9512C31.5059 18.9512 32.9072 20.1475 32.9072 21.7129C32.9072 22.8613 32.292 23.7158 30.8496 25.1924L28.3818 27.6738V27.708H33.0645V29H26.3174V27.9609L29.8789 24.3311C31.082 23.0801 31.3965 22.5605 31.3965 21.7881C31.3965 20.9131 30.6035 20.2158 29.5781 20.2158C28.498 20.2158 27.6846 20.9951 27.6846 22.0205V22.041H26.2354V22.0273Z",
      fill: "#1C2026",
      id: "progress-digits"
    }, null, -1)
  ])))
}
export default { render: render }